import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../oglasnik-v3/shared/services/auth.service';
import { environment } from '../../../environments/environment';

/**
 * App-wide Bearer token interceptor.
 *
 * Automatski attach-a `Authorization: Bearer <token>` na sve HTTP pozive
 * prema našem API-ju kad je korisnik logiran. Public i auth-issuing rute
 * preskače (vidi skip-list). NE rukuje 401 — refresh flow je zaseban task.
 */

const AUTH_FREE_PATHS = [
  '/auth/authenticate',
  '/auth/register-candidate',
  '/auth/otp/request',
  '/auth/otp/verify',
];
const PUBLIC_PREFIX = '/public/';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // 3rd-party URL (Google Fonts, CDN-ovi) — nikad ne curi token van našeg API-ja
  if (!req.url.startsWith(environment.apiBaseUrl)) return next(req);

  // Token-issuing rute (slanje starog tokena ne pomaže) i public rute (backend ih traži anonymous)
  if (AUTH_FREE_PATHS.some(p => req.url.includes(p))) return next(req);
  if (req.url.includes(PUBLIC_PREFIX)) return next(req);

  // Caller je već postavio header — ne diramo
  if (req.headers.has('Authorization')) return next(req);

  const token = inject(AuthService).accessToken();
  if (!token) return next(req);

  return next(req.clone({
    setHeaders: { Authorization: `Bearer ${token}` },
  }));
};
